export default __webpack_public_path__ + "static/card-50-devices-05231e0375267cb2452c9b45b05786c6.png";